import React from "react";
import { useIsMobile } from "../../../redux/features/device/selectors";
import CheckmarkIcon from "../../../shared-components/icons/CheckmarkIcon";
import { useSubscriptionCompetitionsContext } from "../context";
import Specs from "./Specs";

const ButtonTopBanner = () => {
  const { onViewPlansClick } = useSubscriptionCompetitionsContext();
  return (
    <button
      onClick={() => onViewPlansClick("sc_lobby_top")}
      className="theme-btn theme-btn-primary theme-btn-md lg:theme-btn-2xl min-w-[280px] lg:min-w-[316px] uppercase">
      View plans
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="16"
        height="16"
        viewBox="0 0 16 16"
        fill="none"
        className={"size-4 lg:size-6 shrink-0"}>
        <path
          d="M4.66797 4.66699L8.0013 8.00033L4.66797 11.3337M8.66797 4.66699L12.0013 8.00033L8.66797 11.3337"
          stroke="white"
          stroke-width="1.5"
          stroke-linecap="round"
          stroke-linejoin="round"></path>
      </svg>
    </button>
  );
};

const MainBanner = () => {
  const isMobile = useIsMobile();

  const { isAlreadySubscribed, lobbyContent } = useSubscriptionCompetitionsContext();

  return (
    <div className={"px-6 py-8 lg:pt-[56px] lg:pb-7.5 relative w-full flex"}>
      <img
        src={
          isMobile
            ? "/assets/images/subscription-competitions/main-banner-m.webp"
            : "/assets/images/subscription-competitions/main-banner-d.webp"
        }
        alt="Main Banner"
        width={360}
        height={582}
        className="absolute inset-0 size-full object-cover"
      />
      <div className={"relative w-full max-w-[1280px] mx-auto flex flex-col gap-6 lg:gap-10"}>
        <div className={"lg:flex lg:justify-between lg:gap-8 lg:items-center"}>
          <div className={"lg:max-w-[544px]"}>
            <div
              className={
                "inline-flex min-h-6 lg:min-h-8 justify-center items-center gap-2 rounded bg-black/20 p-2 mb-3 lg:mb-4"
              }>
              <img
                src={"/assets/images/subscription-competitions/botb-pass-coin.png"}
                alt="botb pass coin"
                width={16}
                height={16}
                className="size-4 shrink-0"
              />
              <span className={"text-white font-jost text-[11px] font-medium leading-3.5 lg:text-sm lg:leading-5"}>
                {isAlreadySubscribed ? <>{"Your BOTB Pass Competitions"}</> : <>{"BOTB Pass Competitions"}</>}
              </span>
            </div>
            <div
              className={
                "text-white font-jost text-2xl font-bold leading-7.5 mb-1.5 lg:mb-4 lg:text-[40px] lg:leading-[48px]"
              }>
              {isAlreadySubscribed ? lobbyContent.subSubcribedHeader.title : lobbyContent.unsubSubcribedHeader.title}
            </div>
            <div className={"text-white font-jost text-base font-normal leading-5.5 lg:text-[22px] lg:leading-7"}>
              {isAlreadySubscribed
                ? lobbyContent.subSubcribedHeader.subtitle
                : lobbyContent.unsubSubcribedHeader.subtitle}
            </div>
            {isAlreadySubscribed && (
              <div
                className={
                  "w-full text-white/60 font-jost text-xs font-normal leading-[22px] lg:text-base lg:leading-7 mt-2 lg:mt-4"
                }>
                {lobbyContent.subSubcribedHeader.disclaimer}
              </div>
            )}
            {!isMobile && !isAlreadySubscribed && (
              <div className={"mt-10"}>
                <ButtonTopBanner />
              </div>
            )}
          </div>
          {!isAlreadySubscribed && (
            <div className={"flex flex-col items-start gap-3 max-lg:mt-4.5 lg:max-w-[416px] w-full"}>
              {lobbyContent.unsubSubcribedHeader.perks.map((perk, i) => (
                <div
                  key={i}
                  className="flex items-start gap-3 self-stretch text-white/80 font-jost text-sm font-normal leading-5 lg:text-lg lg:leading-6">
                  <CheckmarkIcon variation={4} className="size-6 shrink-0 text-white" />
                  {perk}
                </div>
              ))}
            </div>
          )}
        </div>
        <Specs />
        <div>
          {isMobile && !isAlreadySubscribed && (
            <div className={"mt-8 flex justify-center"}>
              <ButtonTopBanner />
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default MainBanner;
